import { storeToRefs } from 'pinia';
import { computed } from 'vue';

import { STANDARD_POPULATION_TYPES } from '@/constants/standard_populations';
import { useFeedsStore, usePartnersStore, usePopulationsStore } from '@/stores';

export default function useCallouts() {
  const populationsStore = usePopulationsStore();
  const partnersStore = usePartnersStore();
  const feedsStore = useFeedsStore();
  const { crmFeeds } = storeToRefs(feedsStore);

  const hasPartners = computed(() => partnersStore.partnerOrgs.length > 0);

  const missingStandardPopulations = computed(() => {
    return STANDARD_POPULATION_TYPES.filter((type) => {
      return !populationsStore.populations.find(
        (pop) => pop.standard_type === type,
      );
    });
  });

  const hasAllStandardPopulations = computed(
    () => missingStandardPopulations.value.length === 0,
  );

  function hasValidCrm(crms) {
    const crmLookup = crms.reduce((acc, crm) => {
      acc[crm] = true;
      return acc;
    }, {});

    return crmFeeds.value.some((feed) => crmLookup[feed.integration.type]);
  }

  return {
    missingStandardPopulations,
    hasAllStandardPopulations,
    hasPartners,
    hasValidCrm,
  };
}
